import axios from "./axios";

//加油统计
export const queryOilAddTimeInfo=(data,responseType='json')=>{
	return axios({
		act: "v1/queryOilAddTimeInfo",
		method: "post",
		data: data,
		responseType: responseType
	});
}
//油量曲线
export const querySpeedOilCurve=(data,responseType='json')=>{
	return axios({
		act: "v1/querySpeedOilCurve",
		method: "post",
		data: data,
		responseType: responseType
	});
}

//司机签到签出记录
export const queryDriverSignRec=(data,responseType='json')=>{
	return axios({
		act: "v1/queryDriverSignRec",
		method: "post",
		data: data,
		responseType: responseType
	});
}
